import "core-js/modules/esnext.json.parse.js";
import "core-js/modules/esnext.array.group.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import config from "@/config/fileSelect";
import groupDialog from "./group";
export default {
    emits: [
        'update:modelValue',
        'submit'
    ],
    props: {
        modelValue: null,
        hideUpload: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: config.max
        },
        onlyImage: {
            type: Boolean,
            default: true
        },
        maxSize: {
            type: Number,
            default: config.maxSize
        }
    },
    components: {
        groupDialog
    },
    data () {
        return {
            dialog: {
                save: false
            },
            keyword: null,
            fileName: "",
            pageSize: 18,
            total: 0,
            currentPage: 1,
            data: [],
            menu: [],
            menuId: '',
            value: this.multiple ? [] : '',
            selection: this.multiple ? [] : '',
            fileList: [],
            accept: this.onlyImage ? "image/gif, image/jpeg, image/png, image/webp" : "",
            listLoading: false,
            menuLoading: false,
            treeProps: config.menuProps,
            fileProps: config.fileProps,
            files: config.files,
            query: ''
        };
    },
    watch: {
        multiple () {
            this.value = this.multiple ? [] : '';
            this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.value)));
        }
    },
    mounted () {
        this.getMenu();
    },
    methods: {
        onQueryChanged (query) {
            this.$refs.group.filter(query);
        },
        filterMethod (query, node) {
            return node.group_name.includes(query);
        },
        //获取分类数据
        async getMenu () {
            this.menuLoading = true;
            var res = await config.menuApiObj.post();
            this.menu = res.data;
            if (res.data.length > 0) {
                this.menuId = res.data[0][config.menuProps.key];
                this.$refs.group.setCheckedKeys([
                    res.data[0][config.menuProps.key]
                ]);
            }
            this.getData();
            this.menuLoading = false;
        },
        //获取列表数据
        async getData () {
            this.listLoading = true;
            var reqData = {
                [config.request.groupKey]: this.menuId,
                [config.request.page]: this.currentPage,
                [config.request.pageSize]: this.pageSize,
                [config.request.keyword]: this.keyword,
                [config.request.fileName]: this.fileName
            };
            if (this.onlyImage) {
                reqData.type = 'image';
            }
            var res = await config.listApiObj.post(reqData);
            var parseData = config.listParseData(res);
            this.data = parseData.rows;
            this.total = parseData.total;
            this.listLoading = false;
            this.$nextTick(()=>{
                this.$refs.scrollbar.setScrollTop(0);
            });
        },
        //树点击事件
        groupClick (data) {
            this.menuId = data[config.menuProps.key];
            this.currentPage = 1;
            this.keyword = null;
            this.fileName = "";
            this.getData();
        },
        //分页刷新表格
        reload () {
            this.getData();
        },
        search () {
            this.currentPage = 1;
            this.getData();
        },
        select (item) {
            const itemUrl = item[this.fileProps.url];
            const key = item[this.fileProps.key];
            if (this.multiple) {
                if (this.value.includes(itemUrl)) {
                    this.value.splice(this.value.findIndex((f)=>f == itemUrl), 1);
                    this.selection.filter((item)=>item !== key);
                } else {
                    if (this.value.length === this.max) return;
                    this.value.push(itemUrl);
                    this.selection.push(key);
                }
            } else {
                if (this.value.includes(itemUrl)) {
                    this.value = '';
                    this.selection = '';
                } else {
                    this.value = itemUrl;
                    this.selection = key;
                }
            }
        },
        async deleteFile () {
            this.$msgbox({
                title: "删除选中图片",
                message: "确定要删除选中图片吗？\n删除选中图片后将无法恢复，请谨慎操作！",
                center: true,
                showClose: false,
                showCancelButton: true
            }).then(async ()=>{
                let query = {
                    ids: this.multiple ? this.selection : [
                        this.selection
                    ]
                };
                var res = await config.listDeleteObj.post(query);
                if (res?.code === 1) {
                    this.$notify.success({
                        title: '删除成功'
                    });
                    this.value = this.multiple ? [] : '';
                    this.selection = this.multiple ? [] : '';
                    this.getData();
                }
            }).catch(()=>{
            //
            });
        },
        submit () {
            const value = JSON.parse(JSON.stringify(this.value));
            this.$emit('update:modelValue', value);
            this.$emit('submit', value);
        },
        //上传处理
        uploadChange (file, fileList) {
            file.tempImg = URL.createObjectURL(file.raw);
            this.fileList = fileList;
        },
        uploadBefore (file) {
            const maxSize = file.size / 1024 / 1024 < this.maxSize;
            if (!maxSize) {
                this.$message.warning(`上传文件大小不能超过 ${this.maxSize}MB!`);
                return false;
            }
        },
        uploadRequest (param) {
            var apiObj = config.apiObj;
            const data = new FormData();
            data.append("file", param.file);
            data.append("type", "image");
            data.append("file_name", '新增素材');
            data.append([
                config.fileProps.groupKey
            ], this.menuId);
            // data.append([config.request.menuKey], this.$TOOL.data.get("USER_INFO").id);
            apiObj.post(data, {
                onUploadProgress: (e)=>{
                    param.onProgress(e);
                }
            }).then((res)=>{
                param.onSuccess(res);
            }).catch((err)=>{
                param.onError(err);
            });
        },
        uploadProcess (event, file) {
            file.progress = Number((event.loaded / event.total * 100).toFixed(2));
        },
        uploadSuccess (res, file) {
            this.getData();
            this.fileList.splice(this.fileList.findIndex((f)=>f.uid == file.uid), 1);
            this.$notify.success({
                title: '上传成功'
            });
        },
        uploadError (err) {
            this.$notify.error({
                title: '上传文件错误',
                message: err
            });
        },
        //内置函数
        _isImg (fileUrl) {
            const imgExt = [
                '.jpg',
                '.jpeg',
                '.png',
                '.gif',
                '.bmp',
                '.webp'
            ];
            const fileExt = fileUrl.substring(fileUrl.lastIndexOf(".")).toLocaleLowerCase();
            return imgExt.indexOf(fileExt) != -1;
        },
        _getExt (fileUrl) {
            return fileUrl.substring(fileUrl.lastIndexOf(".") + 1);
        },
        addGroup () {
            this.dialog.save = true;
            this.$nextTick(()=>{
                this.$refs.groupDialog.open('add');
            });
        },
        editGroup (data) {
            this.dialog.save = true;
            this.$nextTick(()=>{
                this.$refs.groupDialog.open('edit', data);
            });
        },
        delGroup (data) {
            this.$confirm(`确定当前分类吗？`, '提示', {
                type: 'warning'
            }).then(async ()=>{
                let res = await this.$API.common.file.group.delete.post({
                    id: data[config.menuProps.key]
                });
                if (res?.code === 1) {
                    this.$message.success("操作成功");
                    this.getMenu();
                }
            }).catch(()=>{});
        },
        handleSuccess () {
            this.getMenu();
        }
    }
};
